import request from "@/router/axios";

export const getList = (data) => {
  return request({
    url: '/api/produce/out-in-stock-record/select/page',
    method: 'post',
    data
  })
}

/** 导出 Excel（筛选条件与列表查询一致，服务端生成） */
export const exportExcel = (params) => {
  return request({
    url: '/api/produce/out-in-stock-record/export/excel',
    method: 'post',
    data: params,
    responseType: 'blob'
  })
}
